module.exports = __webpack_public_path__ + "img/div-03.98ff1afe.png";